<template>
    <h2><span class="step-header-title">{{ stepTitle }}</span> <span v-show="stepTitle !== 'Equity Growth'" id="tooltip-id" ref="tooltip-id" @mouseover="showTooltip" @mouseleave="hideTooltip" class="label-tooltip rounded-circle">?<span v-show="activeTooltip" class="calc-tooltip"><div class="arrow-up"></div>{{ tooltipText }}</span></span></h2>
</template>

<script>
    export default {
        name: "step-title",
        data () {
            return {
                activeTooltip: false
            }
        },
        props: {
            stepTitle: String
        },
        computed: {
            tooltipText: function () {
                var helpText = "";

                switch (this.stepTitle) {
                    case 'Purchase Costs':
                        helpText = "This step captures the capital related costs of the property such " +
                            "as the purchase price, deposit and other initial costs. It calculates the " +
                            "stamp duty payable based on the Suburb + State entered. The user also has " +
                            "the ability to select 'Cash', or 'Equity' for the purchase costs if " +
                            "they are borrowing equity from another property.  If 'Equity' is selected, " +
                            "the calculator will apply an interest charge to all purchase costs in the calculation.";
                        break;
                    case 'Income and Expenses':
                        helpText = "This step requires the weekly income (rent) and various yearly expenses " +
                            "to be entered. Also, in this step are any interest or principal repayments based " +
                            "on whether the loan is 'Interest Only' or 'Principal & Interest'. With " +
                            "'Principal & Interest', the loan amount is repaid over a selected loan term. " +
                            "‘Interest Only’ loans don’t pay down any of the loan, however will result in " +
                            "a better yearly cashflow position as no principal repayment is made.";
                        break;
                    case 'Tax Factors':
                        helpText = "This step captures the yearly income or salary of the user and " +
                            "calculates the applicable ATO marginal tax rate. It also estimates the " +
                            "depreciation amount, or the tax deduction for the wear and tear " +
                            "over time on the property. The depreciation calculation comes courtesy " +
                            "of Washington Brown Quantity Surveyors.";
                        break;
                    case 'Cashflow Estimate (First Year)':
                        helpText = "The final step of the calculator reveals the first-year results of " +
                            "the data entered. These calculations show the relationship between the " +
                            "property’s rental income and expenses, with and without tax implications " +
                            "(i.e. post-tax and pre-tax). The results are displayed in weekly and annual amounts. " +
                            "This step also includes an equity growth table where the user can enter " +
                            "a chosen average capital growth figure and see what the compounding effect of " +
                            "this growth is over a 10-year period. It also shows the remaining loan balance " +
                            "and subsequent equity the user may accumulate over this time.";
                        break;
                }

                return helpText;
            }
        },
        methods: {
            showTooltip: function () {
                this.activeTooltip = true;
            },
            hideTooltip: function () {
                this.activeTooltip = false;
            }
        },
        mounted() {

            let $vm = this;
            var tooltip = this.$refs['tooltip-id'];
            tooltip.addEventListener('touchstart', function () {
                $vm.activeTooltip = !$vm.activeTooltip;
            })
        }
    }
</script>

<style scoped>

    h2 {
        background: #465978;
        font-family: 'Roboto', Arial, serif;
        color: #fff;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        font-weight: bold;
        width: auto;
        word-wrap: break-word;
        display: flex;
        justify-content: space-between;
    }

    .label-tooltip {
        background-color: white;
        width: 30px;
        border-radius: 50%;
        color: #465978;
        font-weight: bold;
        font-size: 26px;
        display: inline-block;
        font-family: 'Roboto', Arial, serif;
        position: relative;
        cursor: pointer;
        align-self: center;

        height: 0;
        padding: 15px 0%;
        line-height: 0;
        text-align: center;
    }

    .calc-tooltip {
        position: absolute;
        z-index: 99;
        top: 30px;
        left: -420px;
        background-color: #465978;
        height: 118px;
        width: 600px;
        color: #fff;
        line-height: 16px;
        padding: 8px;
        opacity: 0.9;
        margin-left: -475%;
        overflow: hidden;
        font-size: 16px;
        padding-top: 0;
        text-transform: none !important;
        letter-spacing: normal !important;
    }

    .arrow-up {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid black;
        margin-left: 560px;
        margin-bottom: 0;
        margin-top: 5px;
    }

    .tax-factors-title .calc-tooltip {
        height: 100px;
    }

    .cashflow-estimate-header .calc-tooltip {
        height: 148px;
    }

    @media (max-width: 895px) {
        .calc-tooltip {
            height: 178px;
            width: 400px;
            left: -220px;
        }
        .arrow-up {
            margin-left: 360px;
        }

        .tax-factors-title .calc-tooltip {
            height: 134px;
        }

        .cashflow-estimate-header .calc-tooltip {
            height: 228px;
        }
    }

    @media (max-width: 546px) {
        .cashflow-estimate-header .step-header-title {
            width: 90%;
        }
    }

    @media (max-width: 432px) {
        .calc-tooltip {
            height: 338px;
            width: 200px;
            left: -20px;
        }
        .arrow-up {
            margin-left: 160px;
        }

        .income-and-expenses-title .calc-tooltip {
            height: 354px;
        }

        .tax-factors-title .calc-tooltip {
            height: 278px;
        }

        .cashflow-estimate-header .calc-tooltip {
            width: 280px;
            height: 310px;
            margin-left: -745%;
        }

        .cashflow-estimate-header .arrow-up {
            margin-left: 240px;
        }
    }

    @media (max-width: 422px) {
        .income-and-expenses-title .step-header-title {
            width: 70%;
        }
    }

    @media (max-width: 328px) {
        .purchase-costs-header .step-header-title {
            width: 70%;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/StepTitle.vue